import { Collection } from '@/state/Collection';
import { _RESIDENTS } from "@/state";

import { ResidentsRoutes } from '@/repository/tenant';
const { GetAllResidents, GetResident, CreateResident, UpdateResident, DeleteResident } = ResidentsRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		_all: new Collection({
			statePath: 'tenant.residents.all',
			autoSortRule: { key: 'display_name', asc: true }
		})
	},
	actions: {
		// Get all Users connected to tenant
		async index({ commit }, args) {
			try {
				let { page, per_page } = Object.assign({}, args)
				let res = await GetAllResidents({ page, per_page });
				commit('SET_RESIDENTS_LIST', res.data);
			}
			catch (error) {
				console.error('Residents could not be indexed.', error);
				throw error;
			}
		},

		async indexNextPage({ commit }) {
			try {
				if (_RESIDENTS().pagination.isLastPage()) {
					return;
				}
				let res = await GetAllResidents({ page: _RESIDENTS().pagination.nextPage() })
				commit('APPEND_MULTIPLE_RESIDENTS_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of residents could not be indexed.', error);
				throw error;
			}
		},

		// Get Single Resident
		async show({ }, { residentId, sprintId }) {
			try {
				let res = await GetResident({ resident: residentId, sprint: sprintId });
				return res.data
			}
			catch (error) {
				console.error('Resident could not be shown.', error);
				throw error;
			}
		},

		async createOrUpdate({ commit }, { resident }) {
			try {
				let res = {}
				if (resident.id) {
					res = await UpdateResident({ resident });
					commit('UPDATE_RESIDENT', res.data)
				}
				else if (!resident.id) {
					res = await CreateResident({ resident });
					commit('APPEND_SINGLE_RESIDENT_TO_LIST', res.data)
				}
				return res
			}
			catch (error) {
				console.error('Resident could not be created/updated.', error);
				throw error;
			}
		},

		// Delete User >>> Remove from Tenant
		async delete({ commit }, { resident }) {
			try {
				let res = await DeleteResident({ resident });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting Resident.';
				}
				commit('DELETE_RESIDENT', resident)
				return true;
			}
			catch (error) {
				console.error('Resident could not be deleted.', error);
				throw error;
			}
		},


	},
	mutations: {
		SET_RESIDENTS_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		APPEND_MULTIPLE_RESIDENTS_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		APPEND_SINGLE_RESIDENT_TO_LIST(state, obj) {
			state._all.items.append(obj).commitToState();
		},
		UPDATE_RESIDENT(state, obj) {
			state._all.items.updateItem(obj).commitToState();
		},
		DELETE_RESIDENT(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		},
	}
}